/* eslint-disable import/prefer-default-export */

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * 最終再生日からの経過日数を計算して文字列を返す。
 * 返す文字列は以下の通り
 * 0日: today 1日: yesterday その他: {経過日数} days ago
 * @param playdt
 * @returns 経過日数
 */
export const convertElapsedDate = (playdt: string): string => {
  if (!playdt) {
    // 空文字の場合return
    return '';
  }

  // playdtをDate型に変換
  const date = new Date(playdt);

  // 時分秒切り捨て
  const dateNotTime = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  // playdtの時刻を切り捨てたミリ秒取得
  const unixDate = dateNotTime.getTime();

  // 現在日時を取得
  const now = new Date();

  // 現在日時の時分秒切り捨て
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // 現在日時の時刻を切り捨てたミリ秒取得
  const unixNow = nowDate.getTime();

  // 経過日数のミリ秒を取得
  const uniElapsed = unixNow - unixDate;

  // ミリ秒から経過日数を計算(端数切捨て)
  const elapsedDate = Math.floor(uniElapsed / (1000 * 60 * 60 * 24));

  if (elapsedDate > 7) {
    const dt = new Date(playdt);

    return `${monthNames[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
  }

  if (elapsedDate === 0) {
    return 'today';
  }

  if (elapsedDate === 1) {
    return 'yesterday';
  }

  return `${elapsedDate} days ago`;
};
